const financialChecks = [
  {
    path: '/financial/checks',
    name: 'Checks',
    redirect: { name: 'OpenChecks' },
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/check/Checks'),
    children: [
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: '/financial/checks/open',
        name: 'OpenChecks',
        component: () => import('@/_backoffice/_financial/components/check/OpenChecks'),
      },
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: '/financial/checks/completed',
        name: 'CompletedChecks',
        component: () => import('@/_backoffice/_financial/components/check/CompletedChecks'),
      }
    ]
  },
]

export default financialChecks
